module.exports = __webpack_public_path__ + "static/media/Recipes.18553dcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Recipes.svg
// module id = 510
// module chunks = 11